import { post } from 'axios';
import cookie from 'react-cookies';
import API from '../../settings/api';

function failureText( err, fallback ) {

  if ( typeof err === 'string' && err ) { return err; }
  if ( err?.message ) { return err.message; }

  return fallback;

}

export async function load( store, payload = {} ) {

  const token = cookie.load( 'token' );

  const body = {

    periodType: payload.periodType,
    startDate: payload.startDate,
    endDate: payload.endDate,

  };

  try {

    const { status, data } = await post( API.companies.stats.own, body, { headers: { token } } );

    if ( status !== 200 || !data?.success || !data?.stats ) {

      throw ( data?.text || 'Не удалось загрузить статистику' );

    }

    return {

      success: true,
      stats: data.stats,

    };

  } catch ( err ) {

    const fromServer = err?.response?.data?.text;

    if ( fromServer ) {

      return {

        success: false,
        text: failureText( fromServer, 'Не удалось загрузить статистику' ),

      };

    }

    if ( typeof err === 'string' && err ) {

      return {

        success: false,
        text: err,

      };

    }

    return {

      success: false,
      text: 'Не удалось загрузить статистику',

    };

  }

}
